import { Injectable } from '@angular/core';
import { WebService } from './web.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomerCrmService {
  constructor(private web: WebService) { }

  createCustomer(customer: any): Observable<any> {
    return this.web.getWebCall('customers', 'coffee/customers', { body: customer });
  }

  updateCustomerOverview(customer: any): Observable<any> {
    return this.web.getWebCall('customers', 'coffee/customers/overview', { body: customer });
  }

  searchCustomers(searchTerm: string, includeInactive: boolean): Observable<any> {
    return this.web.getWebCall('customers', 'coffee/customers/search', {
      params: [
        { name: 'SearchTerm', value: searchTerm || '' },
        { name: 'IncludeInactive', value: includeInactive }
      ]
    });
  }

  getDashboardStats(): Observable<any> {
    return this.web.getWebCall('customers', 'coffee/customers/dashboard-stats');
  }

  getCustomerDetails(companyId: number): Observable<any> {
    return this.web.getWebCall('customers', `coffee/customers/${companyId}/details`);
  }

  getRelatedCustomers(companyId: number): Observable<any> {
    return this.web.getWebCall('customers', `coffee/customers/${companyId}/related`);
  }

  getReserves(companyId:number):Observable<any>{return this.web.getWebCall('customers', `coffee/customers/${companyId}/reserves`);}

  getContacts(companyId: number): Observable<any> {
    return this.web.getWebCall('customers', `coffee/customers/${companyId}/contacts`);
  }

  saveContact(contact: any): Observable<any> {
    return this.web.getWebCall('customers', 'coffee/customers/contacts', { body: contact });
  }

  deactivateContact(customerContactId: number, modifiedBy: string | null): Observable<any> {
    return this.web.getWebCall('customers', 'coffee/customers/contacts/delete', {
      body: { CustomerContactID: customerContactId, ModifiedBy: modifiedBy }
    });
  }

  getShipToAddresses(companyId: number): Observable<any> {
    return this.web.getWebCall('customers', `coffee/customers/${companyId}/ship-to-addresses`);
  }

  saveShipToAddress(address: any): Observable<any> {
    return this.web.getWebCall('customers', 'coffee/customers/ship-to-addresses', { body: address });
  }

  deactivateShipToAddress(customerShipToAddressId: number, modifiedBy: string | null): Observable<any> {
    return this.web.getWebCall('customers', 'coffee/customers/ship-to-addresses/delete', {
      body: { CustomerShipToAddressID: customerShipToAddressId, ModifiedBy: modifiedBy }
    });
  }

  getPaymentPreference(companyId: number): Observable<any> {
    return this.web.getWebCall('customers', `coffee/customers/${companyId}/payment-preference`);
  }

  savePaymentPreference(preference: any): Observable<any> {
    return this.web.getWebCall('customers', 'coffee/customers/payment-preference', { body: preference });
  }

  getNotes(companyId: number, includeHistory: boolean = false): Observable<any> {
    return this.web.getWebCall('customers', `coffee/customers/${companyId}/notes`, {
      params: [{ name: 'IncludeHistory', value: includeHistory }]
    });
  }

  saveNote(note: any): Observable<any> {
    return this.web.getWebCall('customers', 'coffee/customers/notes', { body: note });
  }

  getAuditHistory(companyId: number): Observable<any> {
    return this.web.getWebCall('customers', `coffee/customers/${companyId}/audit-history`);
  }

  getOrderHistory(companyId: number): Observable<any> {
    return this.web.getWebCall('customers', `coffee/customers/${companyId}/order-history`);
  }

  // All order_payment entries across every order for this customer, in one set-based
  // call - not a per-order loop. See get_customer_order_payments proc.
  getCustomerOrderPayments(companyId: number): Observable<any> {
    return this.web.getWebCall('customers', `coffee/customers/${companyId}/order-payments`);
  }

  getSampleHistory(companyId: number): Observable<any> {
    return this.web.getWebCall('customers', `coffee/customers/${companyId}/sample-history`);
  }

  saveSampleRequest(sample: any): Observable<any> {
    return this.web.getWebCall('customers', 'coffee/customers/sample-requests', { body: sample });
  }

  updateCustomerStatus(companyId: number, inactive: boolean, modifiedBy: string | null): Observable<any> {
    return this.web.getWebCall('customers', 'coffee/customers/status', {
      body: { CompanyID: companyId, Inactive: inactive, ModifiedBy: modifiedBy }
    });
  }

  getPastDueSummary(): Observable<any> {
    return this.web.getWebCall('customers', 'coffee/customers/past-due/summary');
  }

  // Existing lookups, reused as-is (not part of the 5.3 CRM build)
  getPaymentTerms(): Observable<any> {
    return this.web.getWebCall('data', 'coffee/payment-terms');
  }

  getPaymentMethods(): Observable<any> {
    return this.web.getWebCall('data', 'coffee/payment-methods');
  }

  getInventoryTypes(): Observable<any> {
    return this.web.getWebCall('inventory', 'coffee/inventory-types');
  }

  getTraders(): Observable<any> {
    return this.web.getWebCall('data', 'coffee/traders');
  }
}
